import { PAGE_SIZE } from "@faire/retailer-shared/search/searchRequest";

export const useSearchPagePageSize = () => {
  return PAGE_SIZE;
};
